<script setup lang="ts">
defineSlots<{
  page: () => void;
}>();
</script>

<template>
  <div>
    <NuxtErrorBoundary>
      <slot name="page" />
      <template #error="{ error }">
        <ErrorPage :error="createError(error)" />
      </template>
    </NuxtErrorBoundary>
  </div>
</template>
